import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoCorrect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAutoCorrect"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0418 0.89502L16.2086 14.8436H5.51508L3.12972 20.239L1.75781 19.6325L10.0418 0.89502ZM6.17824 13.3436H13.9054L10.0418 4.60463L6.17824 13.3436ZM22.2871 13.5418L16.3636 22.4271L12.6864 18.7498L13.747 17.6892L16.1305 20.0726L21.039 12.7098L22.2871 13.5418Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoCorrect;
